import { render, staticRenderFns } from "./BocomLogin.vue?vue&type=template&id=1e6b46d3&scoped=true"
import script from "./BocomLogin.vue?vue&type=script&lang=js"
export * from "./BocomLogin.vue?vue&type=script&lang=js"
import style0 from "./BocomLogin.vue?vue&type=style&index=0&id=1e6b46d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6b46d3",
  null
  
)

export default component.exports